import React, { useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';

const AccountActivated = () => {
  // Redirect after 3.5 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      window.location.href = 'https://us.rs-online.com/';
    }, 3500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-white font-sans text-gray-900">
      {/* RS Header */}
      <Header />

      {/* Main Content Area */}
      <main className="flex-1 max-w-7xl w-full mx-auto px-4 sm:px-8 py-16 flex flex-col items-center justify-center text-center">
        <div className="w-full max-w-lg bg-white border border-gray-200 p-10 shadow-sm">
          {/* Green checkmark */}
          <div className="w-14 h-14 mx-auto rounded-full border-2 border-[#16a34a] flex items-center justify-center mb-6">
            <svg
              className="w-8 h-8 text-[#16a34a]"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>

          <h1 className="text-2xl font-bold text-[#111111] mb-3">
            Thank you!
          </h1>
          <p className="text-base text-gray-700 font-medium">
            Your account has been verified.
          </p>
          <p className="text-sm text-gray-500 mt-3">
            Redirecting to RS portal shortly...
          </p>

          <div className="mt-8">
            <a
              href="https://us.rs-online.com/"
              className="inline-block bg-[#2A437E] hover:bg-[#203463] text-white font-semibold text-xs tracking-wider uppercase px-6 py-2.5 transition-colors"
            >
              Continue to RS
            </a>
          </div>
        </div>
      </main>

      {/* RS Footer */}
      <Footer />
    </div>
  );
};

export default AccountActivated;
